import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  fallbackLng: "en",
  lng: "en",
  resources: {
    en: {
      translations: require("./locales/en/translations.json"),
    },
    enUs: {
      translations: require("./locales/enUS/translations.json"),
    },
    hi: {
      translations: require("./locales/hi/translations.json"),
    },
    gu: {
      translations: require("./locales/gu/translations.json"),
    },
    as: {
      translations: require("./locales/as/translations.json"),
    },
    kn: {
      translations: require("./locales/kn/translations.json"),
    },
    te: {
      translations: require("./locales/te/translations.json"),
    },
    mr: {
      translations: require("./locales/mr/translations.json"),
    },
    or: {
      translations: require("./locales/or/translations.json"),
    },
  },
  ns: ["translations"],
  defaultNS: "translations",
  react: { useSuspense: false },
});

i18n.languages = ["en", "hi", "gu", "as", "kn", "te", "mr", "or", "enUs"];

export default i18n;
